const iframeUrls = {
  local: process.env.VUE_APP_TEST_URL || '',
  test: process.env.VUE_APP_IFRAME_BASE_URL_TEST || '',
  domain: process.env.VUE_APP_IFRAME_BASE_URL_DOMAIN || '',
  production: process.env.VUE_APP_IFRAME_BASE_URL || ''
}

const isIframeUrl = (inputUrl: string): string | boolean => {
  const matchedUrl = Object.values(iframeUrls).find(url => url === inputUrl)
  return matchedUrl ?? false
}

export {
  isIframeUrl
}
